module.exports = "/images/magnet-1958.jpg?e414b15ac819b319814975c1c083babf";